import BaseModel from '../core/BaseModel'
export default class OfficeVPLKModel extends BaseModel {

    constructor() {
        super({ 
                name: "office_vplk",
                tableName: 'office_vplk', 
                label: "Danh Sách văn phòng liên kết", 
                display_key: 'name', 
                default_order: { key: 'id', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                width: 4,
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Int", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            code: {
                name: 'code', 
                type: "String",
                label: 'Mã VP liên kết',
                width :15, 
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            name: {
                name: 'name', 
                type: "String",
                label: 'Tên VP liên kết',
                width :15, 
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            phone: {
                name: 'phone', 
                type: "String",
                label: 'Số điện thoại',
                width :15, 
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            bank_ref: { 
                refs: 'bank {id name}',
                display: false
            },
            display_bank: {
                name: 'display_bank', 
                label: 'Ngân hàng',
                width :10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_bank = '';
                    if(data.bank !== undefined && data.bank !== null){
                        data.display_bank = data.bank.name;
                    }
                }
            },
            account_holder: {
                name: 'account_holder', 
                type: "String",
                label: 'Chủ tài khoản',
                width :10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            account_number: {
                name: 'account_number', 
                type: "String",
                label: 'Số tài khoản',
                width :10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            address: {
                name: 'address', 
                type: "String",
                label: 'Địa chỉ',
                width :10,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            tax_code: {
                name: 'tax_code', 
                type: "String",
                label: 'Mã số thuế',
                width :10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            office_vplk_tpl: {
                name: 'office_vplk_tpl', 
                type: "String",
                label: 'Mã văn phòng TPL',
                width :10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
        },)
    }

}